var aprops = {
  "title": "Reseller Registration for Sampson B2B",
  "name": "reseller",
  "sname": "Reseller Registration",
  "slist":['regForm', 'clientsIncludes', 'orderInfo', 'deliveryInfo'],
  "orderinfo":{
    "minpur":"In order to open a reseller account, the minimum order amount for your first order is HK$ 4,000 but there is no restriction afterwards, you can replenish whatever amount/quantity you want.",
    "minamt":4000
  },
  "deliveryinfo":{
    "payment":"Prior to delivering the products, all orders must be fully paid to our bank account in Hong Kong (* Bank details will be provided to you after the reseller registration is successfully completed). All transaction fee should also be responsible by the reseller. Should you need to use credit card for payment, a 3.5% payment surcharge will be  to your invoice (including any required delivery charge).",
    "delivery":"For delivery, we will generally use Shun Fung Express for delivery to Hong Kong and Macau customers and you should pay to the courier directly. For customers in other country and region, we will use Air Parcel or EMS service by the Hong Kong Post Office. Exact postage will be  to your invoice for payment.",
    "doreg":"Please fill out the form below with all required document. If you have any question, please call us at +852 3165-8845 during our office hours. Price list will only be offered to registered customers."
  },
  "content": `<p class="resellerinfo">This site serves as our distribution business to serve the resellers and bulk purchase customers. We DO NOT sell to individual or general public. For retail sales, please visit SampsonStore.com.</p>`
}


import Vue from 'vue'
import VueResource from 'vue-resource'
import VueCookie from 'vue-cookie';
Vue.use(VueResource);
Vue.use(VueCookie);

import header from '../../components/Header'
import mainbody from '../../components/MainBody'
import utils from '../../components/Utils.vue'

var locale = utils.getLocale();
if (locale == null) {
  locale = "?";
} else {
  locale = '?locale='+locale;
}
locale = locale + '&pagename=reseller';

Vue.http.get('json/reg.json'+locale).then(response => {
  var props = JSON.parse(response.bodyText);

  Vue.http.get(utils.getServerPath()+'/reseller/data.is'+locale).then(response => {
    var data = JSON.parse(response.bodyText);
    if (!props.info) {
      props.info = {};
    }
    Object.keys(data).forEach(function(key) {
      props.info[key] = data[key];
    });

    new Vue({ // eslint-disable-line no-new
      el: '#header',
      render: function(h) {
        if (props.info.common_res != null) {
          return h(header, {props:{name:props.name, header_text:props.info.common_res.header_text}});
        } else {
          return h(header, {props:{name:props.name}});
        }
      }
    })
    new Vue({ // eslint-disable-line no-new
      el: '#mainbody',
      created: function() {
        var self = this;
      },
      render: function(h) {
        return h(mainbody, {
          props:props,
          on: {
            doregister:function(obj) {
              window.location.href='thankyou.html';
            }
          }
        });
      }
    })
  });
}, response => {
});



// WEBPACK FOOTER //
// ./src/pages/reg/index.js